import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Col, Row, Card } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AUDIT_MESSAGES } from "../../../shared/constants/Constants";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import { loadChatMetricsDataRequest, loadUserMetricsDataRequest } from "../redux/Actions";
import AuditUsers from "./AuditUsers";
import AuditGroups from "./AuditGroups";


const AuditMessages = () => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let location = useLocation();
  let {chatmetrics, user} = useSelector((state) => state.chatgroup);
  console.log("Data", chatmetrics,user);
  
  let [currentTracker, setCurrentTracker] = useState(location.search === "?products" ? 2 : 1);

  useEffect(() => {
    dispatch(loadChatMetricsDataRequest());
    dispatch(loadUserMetricsDataRequest());
  }, [dispatch]);

  let trackers = [
    <AuditUsers />,
    <AuditGroups />
  ];

  return (
    <>
      <div>
        <Row>
          <Col className="gx-0">
            <Breadcrumbs
              children={[
                { label: AUDIT_MESSAGES },
              ]}
            />
          </Col>
          <Col xs="auto" className="gx-0"></Col>
        </Row>
        <Row>
          <Col>
            <button
              className={currentTracker === 1 ? "top-tab selected" : "top-tab"}
              onClick={() => {
                navigate("/auditmessages");
                setCurrentTracker(1);
              }}
            >
              Users
            </button>
            <button
              className={currentTracker === 2 ? "top-tab selected" : "top-tab"}
              onClick={() => {
                navigate("/auditmessages");
                setCurrentTracker(2);
              }}
            >
              Group
            </button>
            <Card> <Card.Body >{trackers[currentTracker - 1]} </Card.Body> </Card>
            </Col>
        </Row>
      </div>
    </>
  );
};

export default AuditMessages;

function StatTile({ number, color, onClick, text, icon }) {
  return (
    <Card
      className="statCard clickable"
      style={{ borderLeft: `3px solid ${color}` }}
      onClick={onClick}
    >
      <Card.Body>
        <div className="d-flex align-items-center">
          <div>
            <p className="mb-0 text-secondary statTile-txt" style={{  }} >{text}</p>
            <h4 className="my-1" style={{ color: color }}>
              {number}
            </h4>
          </div>
          <div
            className="widgets-icons-2 rounded-circle text-white ms-auto"
            style={{
              background: `linear-gradient(45deg, ${color}, 80%, #f28f3420), 100%`,
            }}
          >
            <i className={icon}></i>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}